export default [
  {
    path: '/Calendar/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'Calendar',
        component: () => import('@/views/Calendar/Calendar.vue'),
        meta: {
          prev: 'goHome'
        }
      }
    ]
  }
]
